import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IPreferencesSearchService = ( createDecorator('preferencesSearchService'));
export { IPreferencesSearchService };
